<div>
  <div class="mt-4">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title title_header_0">Step 1 - Upload Documents</h5>

        <form [formGroup]="productDetails">
          <div class="row d-flex upload-components">
            <div class="col-lg-3 col-sm-3 col-md-3 overlay_1 upload-component">
              <span class="form_field"> Branch</span>
              <div class="custom-input">
                <input
                  class="readOnly grey_background"
                  type="text"
                  pInputText
                  readOnly="true"
                  formControlName="branchName"
                />
                <span class="p-error" style="font-size: 0.5rem" *ngIf="noBranch"
                  >Please Select a Branch
                </span>
              </div>

              <!-- <div class="d-flex align-items-center gap-2 p-3 checkbox">
                              <input 
                                    class="checkbox-in" 
                                    type="checkbox" 
                                    id="estampCheckbox"
                                   [checked]="isEStampEnabled"
                                   (change)="onEStampToggle($event)"
                                />
                            <label class="checkbox-la" for="estampCheckbox">
                                Do you want E-Stamp for Each Document?
                            </label>
                            </div> -->
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3 overlay_1 upload-component">
              <span class="form_field">
                {{
                  showHdfcFields
                    ? "File number (As per HDFC Bank Sanction
                letter)"
                    : "Reference
                Number"
                }}
                <span class="color_red">*</span></span
              >
              <div class="custom-input">
                <input
                  type="text"
                  pInputText
                  formControlName="referenceNumber"
                  placeholder="Allows alphabets ,numbers and hyphen"
                  [ngClass]="enableRefIdField ? '' : 'grey_background'"
                  onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                       (event.charCode >= 97 && event.charCode <= 122) || 
                       (event.charCode >= 48 && event.charCode <= 57) || 
                       (event.charCode === 45) || (event.charCode === 95)"
                  [readOnly]="!enableRefIdField"
                  (paste)="onReferencePaste($event)"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    productDetails.get('referenceNumber')?.hasError('required')
                  "
                  >Enter reference No.</span
                >
                                
               <span
                class="p-error"
                style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                *ngIf="productDetails.get('referenceNumber')?.hasError('maxlength')"
                     > *Maximum 80 characters allowed
                </span>
                <span
                  class="p-error"
                  style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                  *ngIf="productDetails.get('referenceNumber')?.hasError('invalidChars') && productDetails.get('referenceNumber')?.touched">
                  *Only alphabets, numbers, _ and - are allowed
                </span>

              </div>
            </div>

            <div
              class="col-lg-2 col-sm-2 col-md-2 overlay_1 upload-component"
              *ngIf="isContractExpiryDate"
            >
              <span class="form_field"
                >Contract Expiry Date
                <span class="color_red">*</span>
              </span>
              <p-datepicker
                #calendar
                class="custom-calendar"
                formControlName="expiry_date"
                [minDate]="minExpiryDate"
                placeholder="Select Date"
                [showIcon]="true" iconDisplay="input"
                [readonlyInput]="false"
                inputId="expiry-date"
                dateFormat="dd/mm/yy"
                [required]="isContractExpiryDate"
              >
              </p-datepicker>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  isContractExpiryDate &&
                  productDetails.get('expiry_date')?.invalid
                "
              >
                Please select a valid expiry date
              </span>
            </div>

            <div
              class="row col-lg-5 col-sm-4 col-md-4 upload-component">
              <span class="form_field" style="display: block"
                >Upload the PDF <span *ngIf="showDocs">or DOCX</span>
                documents
                <span class="color_red">*</span></span
              >
              <div class="d-flex align-items-center gap-2">
                <a
                  style="font-size: 10px; color: #612e86"
                  class="btn-link upload-btn"
                >
                  <p-button
                    data-bs-toggle="modal"
                    data-bs-target="#uploadDocModal"
                    label="Upload"
                    (click)="openUploadModal()"
                    styleClass="p-button-sm-outline upload_button_label clickable"
                  >
                    <i class="upload_icon_color bx bx-upload bx-sm"></i>
                  </p-button>
                </a>

                <!-- Eye Preview Button next to Upload button (shown when files uploaded) -->
                <button
                  *ngIf="showFileName && uploadFiles.length > 0"
                  type="button"
                  class="btn-preview-eye"
                  (click)="previewUploadedFile()"
                  pTooltip="Preview Document"
                  tooltipPosition="top"
                  style="border: none; background: transparent; padding: 4px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer;"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#612e86" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </div>

              <div *ngIf="showFileName" class="mt-1">
                <span
                  *ngFor="let file of uploadFiles; let i = index"
                  class="badge background_color_3 status_title_1"
                  style="color: #151515; font-size: 0.7rem; cursor: pointer;"
                  (click)="previewUploadedFile(i)"
                >
                  {{ file.name }}
                  <i
                    class="clickable ms-2 bx bx-x"
                    (click)="$event.stopPropagation(); removeFileName(i)"
                  ></i>
                </span>
              </div>
              <span
                class="p-error"
                style="font-size: 0.65rem"
                *ngIf="submitted && uploadFiles.length === 0"
                >Please upload the documents</span
              >
              <span
                class="p-error"
                style="font-size: 0.65rem"
                *ngIf="chooseFile"
                >Please Select documents to Upload</span
              >
              <!-- <span
                class="p-error"
                style="font-size: 0.65rem; margin-top: 10px"
                *ngIf="fileSizeError"
              >
                File size exceeds maximum limit of 50MB. Please upload a smaller
                file.
              </span> -->
            </div>
          </div>
        </form>
        <div class="row col-lg-4 col-sm-4 col-md-4 mt-4 upload-component">
          <div class="field-checkbox">
            <span class="form_field">Is uploaded file Document Type ? </span>
            <div
              class="form_field"
              style="
                display: flex;
                margin-top: 1rem;
                justify-content: space-between;
              "
            >
              <div class="field-radiobutton" style="display: flex">
                <label for="city1">Finacial Document</label>&nbsp;&nbsp;&nbsp;
                <p-radioButton
                  name="city"
                  value="001"
                  [(ngModel)]="isDocumentType"
                  (onClick)="onDocumentType($event)"
                  inputId="city1"
                ></p-radioButton>
              </div>

              <div class="field-radiobutton" style="display: flex">
                <label for="city2">Operational Document</label
                >&nbsp;&nbsp;&nbsp;
                <p-radioButton
                  name="city"
                  value="002"
                  [(ngModel)]="isDocumentType"
                  (onClick)="onDocumentType($event)"
                  inputId="city2"
                ></p-radioButton>
              </div>

              <div class="field-radiobutton" style="display: flex">
                <label for="city3">None</label>&nbsp;&nbsp;&nbsp;
                <p-radioButton
                  name="city"
                  value="003"
                  [(ngModel)]="isDocumentType"
                  (onClick)="clearSelection()"
                  inputId="city3"
                  checked="true"
                ></p-radioButton>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="contractType && showFields">
          <form [formGroup]="dynamicForm">
            <div class="form_outline_sty">
              <strong class="m-1 mt-2 title_header_0">Document details</strong>

              <div class="row form_inputFields">
                <ng-container *ngFor="let item of formData">
                  <ng-container *ngIf="hasVisibleFields(item)">
                    <div class="col-12 col-md-4">
                      <ng-container *ngFor="let key of objectKeys(item)">
                        <ng-container *ngIf="item[key]?.module === 'general'">
                          <!-- Registration Type for Financial Document -->
                          <ng-container
                            *ngIf="
                              key === 'Registration_Type' &&
                              isDocumentType === '001'
                            "
                          >
                            <span class="form_field">{{
                              item[key]?.label
                            }}</span>
                            <span class="color_red" *ngIf="item[key]?.mandatory"
                              >*</span
                            >
                            <div class="flex_row custom-input">
                              <select
                                [formControlName]="key"
                                class="form-select"
                              >
                                <option
                                  *ngFor="let option of item[key]?.options"
                                  [value]="getOptionKey(option)"
                                >
                                  {{ getOptionValue(option) }}
                                </option>
                              </select>
                            </div>
                            <div
                              *ngIf="
                                dynamicForm.get(key)?.invalid &&
                                (dynamicForm.get(key)?.touched || submitted)
                              "
                              class="p-error"
                              style="font-size: 0.5rem; margin-top: 0.5rem"
                            >
                              *This {{ item[key]?.label }} is required.
                            </div>
                          </ng-container>

                          <!-- Registration Type for Operational Document -->
                          <ng-container
                            *ngIf="
                              key === 'Registration_Type' &&
                              isDocumentType === '002'
                            "
                          >
                            <span class="form_field">{{
                              item[key]?.label
                            }}</span>
                            <span class="color_red" *ngIf="item[key]?.mandatory"
                              >*</span
                            >
                            <div class="flex_row custom-input">
                              <select
                                [formControlName]="key"
                                class="form-select"
                                (change)="onRegistrationTypeChange($event)"
                              >
                                <option
                                  *ngFor="let option of item[key]?.options"
                                  [value]="getOptionKey(option)"
                                >
                                  {{ getOptionValue(option) }}
                                </option>
                              </select>
                            </div>
                            <div
                              *ngIf="
                                dynamicForm.get(key)?.invalid &&
                                (dynamicForm.get(key)?.touched || submitted)
                              "
                              class="p-error"
                              style="font-size: 0.5rem; margin-top: 0.5rem"
                            >
                              *This {{ item[key]?.label }} is required.
                            </div>
                          </ng-container>

                          <!-- Other Fields -->
                          <ng-container
                            *ngIf="
                              key !== 'Registration_Type' &&
                              ((isDocumentType === '001' &&
                                (item[key]?.reg_type ==
                                  dynamicForm.get('Registration_Type')?.value ||
                                  dynamicForm.get('Registration_Type')?.value ==
                                    'ENT')) ||
                                (isDocumentType === '002' &&
                                  dynamicForm.get('Registration_Type')
                                    ?.value === 'ENT'))
                            "
                          >
                            <ng-container [ngSwitch]="item[key]?.data_type">
                              <span class="form_field">{{
                                item[key]?.label
                              }}</span>
                              <span
                                class="color_red"
                                *ngIf="item[key]?.mandatory"
                                >*</span
                              >

                              <div
                                class="flex_row custom-input"
                                *ngSwitchCase="'text'"
                              >
                                <input
                                  class="form-control"
                                  [formControlName]="key"
                                  [placeholder]="item[key]?.label"
                                  (input)="onInputChange($event, key)"
                                  [type]="
                                    isNumberField(item[key]?.validators)
                                      ? 'number'
                                      : 'text'
                                  "
                                  pInputText
                                />
                              </div>

                              <div
                                class="flex_row custom-input"
                                *ngSwitchCase="'dropdown'"
                              >
                                <select
                                  [formControlName]="key"
                                  class="form-select"
                                >
                                  <option value="" disabled>
                                    Select {{ item[key]?.label }}
                                  </option>
                                  <option
                                    *ngFor="let option of item[key]?.options"
                                    [value]="getOptionKey(option)"
                                  >
                                    {{ getOptionValue(option) }}
                                  </option>
                                </select>
                              </div>

                              <div
                                class="flex_row custom-input"
                                *ngSwitchCase="'date'"
                              >
                                <input
                                  type="date"
                                  pInputText
                                  class="form-control"
                                  [placeholder]="item[key]?.label"
                                  [formControlName]="key"
                                />
                              </div>
                            </ng-container>
                            <div
                              *ngIf="
                                dynamicForm.get(key)?.invalid &&
                                (dynamicForm.get(key)?.touched || submitted)
                              "
                              class="p-error"
                              style="font-size: 0.5rem; margin-top: 0.5rem"
                            >
                              *This {{ item[key]?.label }} is required.
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </form>
        </div>

        <div class="row">
          <div class="col-lg-10 col-sm-10 col-md-10"></div>
          <div
            class="col-lg-2 col-sm-2 col-md-2 text-right d-flex justify-content-end align-items-center"
          >
       <div class="custom_button me-2">
              <p-button
                label="Next"
                (click)="gotoTemplatePage()"
                styleClass="p-button-sm-outline"
              ></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  #uploadDocModal
  class="modal fade"
  id="uploadDocModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <h5 class="title_five fw-semibold">
          Upload Document <span class="text-danger">*</span>
        </h5>
        <button
          #closeUploadPopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="true"
        ></button>
        <button
          type="button"
          class="btn-close"
          (click)="cancelUpload()"
        ></button>
      </div>

      <div class="modal-body px-4 py-2">
        <!-- Drag and Drop Area -->
        <div
          class="upload-area"
          [class.drag-over]="isDragOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
        >
          <div class="upload-content">
            <div class="upload-icon mb-2">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-muted"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17,8 12,3 7,8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <h6 class="upload-title mb-2">Drop your files here</h6>
            <p class="upload-subtitle mb-2">
              or
              <span
                class="text-primary cursor-pointer text-decoration-underline"
                >click to select file</span
              >
            </p>
            <div class="upload-info">
              <small class="text-muted"
                >Supported format:<b> PDF, up to 15 MB</b></small
              >
            </div>
          </div>
        </div>

        <div class="custom-input mt-2">
          <input
            class="readOnly"
            type="text"
            pInputText
            readOnly="true"
            [(ngModel)]="fileName"
            placeholder="Select file"
          />
        </div>

        <div class="file-size">
          <span class="file-size text-muted">{{ getTotalFileSize() }}</span>
        </div>

        <div>
          <span
            class="p-error"
            style="font-size: 0.65rem; margin-top: 10px"
            *ngIf="fileSizeError"
          >
            File size exceeds maximum limit of 15MB. Please upload a smaller
            file.
          </span>
        </div>

        <!-- Cloud Service Integration Icons -->
        <div class="d-flex justify-content-center gap-4 mt-2">
          <div class="cloud-service-icon" title="Google Drive" trackClick="click_google_drive" (click)="openGoogleDrive()">
            <img src="assets/img/g-drive.png" alt="Google Drive" width="48" height="40">
          </div>
          <div
            class="cloud-service-icon"
            title="Upload from Link"
            trackClick="click_upload_from_link"
            (click)="openLink()"
          >
            <img
              src="assets/img/link.png"
              alt="Upload from Link"
              width="48"
              height="40"
            />
          </div>
          <div *ngIf="dropboxEnabled"
            class="cloud-service-icon"
            title="dropbox"
            trackClick="click_dropbox"
            (click)="openDropbox()"
          >
            <img
              src="assets/img/dropbox.png"
              alt="dropbox"
              width="48"
              height="40"
            />
          </div>
          <div
            class="cloud-service-icon"
            title="One Drive"
            trackClick="click_onedrive"
            (click)="openOneDrive()"
          >
            <img
              src="assets/img/onedrive.png"
              alt="One Drive"
              width="48"
              height="40"
            />
          </div>
        </div>
      </div>

      <!-- Hidden File Input -->
      <input
        [hidden]="true"
        type="file"
        id="upload_file"
        (change)="onFileChange($event)"
        accept=".pdf"
        multiple
        #fileInput
      />

      <!-- Modal Footer -->
      <div class="modal-footer border-0 pt-0 px-4 pb-4">
        <div class="d-flex justify-content-end gap-2 w-100">
          <button
            type="button"
            class="btn btn-outline-secondary px-4"
            (click)="cancelUpload()"
            style="border-radius: 6px"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary px-4"
            (click)="uploadSelFile()"
            style="
              background-color: #612e86;
              border-color: #612e86;
              border-radius: 6px;
            "
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-pdf-editor 
  *ngIf="isEditorVisible" 
  [pdfSrc]="currentPdfToEdit" 
  (onComplete)="handleFinalUpload($event)"
  (onCancel)="isEditorVisible = false">
</app-pdf-editor>

<div
  #uploadDocSuccessModalPopup
  data-bs-toggle="modal"
  data-bs-target="#uploadSuccessModal"
></div>

<div
  #uploadSuccessModal
  class="modal fade"
  id="uploadSuccessModal"
  tabindex="-1"
  aria-labelledby="uploadSuccessModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="text-right p-3">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="text-center pb-5">
        <div>
          <img
            src="../../../../assets/img/admin-notified.jpg"
            width="45"
            class="logo_style_0"
          />
        </div>

        <p class="pop_style">Document uploaded successfully!</p>

        <div>
          <p>Your document has arrived its destination in one piece.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Google Drive upload file -->
<app-google-drive-modal
  [isVisible]="showGoogleDriveModal"
  (fileSelected)="onGoogleDriveFileSelected($event)"
  (modalClosed)="onGoogleDriveModalClosed()"
>
</app-google-drive-modal>
<!-- Link upload file modal -->
<app-upload-link
  [isVisible]="showLinkModal"
  (fileSelected)="onLinkFileSelected($event)"
  (modalClosed)="onLinkModalClosed()"
>
</app-upload-link>
<!-- Dropbox upload file modal -->
<app-dropbox-modal *ngIf="dropboxEnabled"
  [isVisible]="showDropboxModal"
  (fileSelected)="onDropboxFileSelected($event)"
  (modalClosed)="onDropboxModalClosed()"
>
</app-dropbox-modal>
<!-- OneDrive upload file modal -->
<app-onedrive-modal
  [isVisible]="showOneDriveModal"
  (fileSelected)="onOneDriveFileSelected($event)"
  (modalClosed)="onOneDriveModalClosed()"
>
</app-onedrive-modal>

<app-document-preview-modal
  [(isVisible)]="previewModalVisible"
  [file]="previewFile"
  [files]="previewModalFiles"
  [fileName]="previewFileName"
  [mode]="previewModalMode"
  (onUpload)="onUploadConfirmed($event)"
  (onCancel)="onUploadCancelled()"
  (onSave)="onPreviewFileSaved($event)"
>
</app-document-preview-modal>
